import React, { useState, useRef } from "react";
import styled from "styled-components";

const Input = styled.input`
  box-shadow: 0px 2px 4px 0px #00000017 inset;
  border: 1px solid #cccccc;
  width: 32px;
  height: 42px;
  border-radius: 8px;
  border-width: 1px;
  font-size: 18px;
  padding: 10px;
  outline: none;
`;

const OTPInput = ({ length = 6, onComplete }: any) => {
  const [otp, setOtp] = useState(new Array(length).fill(""));
  const [isTyping, setIsTyping] = useState<boolean>(false);
  const inputRefs = useRef<any>([]);

  const normalizeFullWidth = (str: string): string => {
    return str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, (char) =>
      String.fromCharCode(char.charCodeAt(0) - 0xfee0)
    );
  };

  const handleChange = (index: number, rawValue: string) => {
    if (isTyping) {
      const normalized = normalizeFullWidth(rawValue);
      // Extract the first numeric character from input
      const match = normalized.match(/[0-9]/);
      const value = match ? match[0] : "";

      if (!value) return;

      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      setIsTyping(false);

      // Move to next input automatically
      setTimeout(() => {
        // if (value && index < length - 1 && inputRefs.current[index + 1]) {
        //   inputRefs.current[index + 1].focus();
        // }
        if (index < length - 1) {
          inputRefs.current[index + 1]?.focus();
        }
        if (onComplete) {
          if (newOtp.every((digit) => digit !== "")) {
            if (inputRefs.current[index] && index === length - 1) {
              inputRefs.current[index].blur();
            }
            onComplete(newOtp.join(""));
          }
          // onComplete(newOtp.join(""));
        }
      }, 70);
    }
  };

  /** Handle Backspace */
  const handleKeyDown = (
    index: number,
    e: React.KeyboardEvent<HTMLInputElement>
  ) => {
    setIsTyping(true);
    if (e.key === "Backspace") {
      e.preventDefault();
      const newOtp = [...otp];

      if (otp[index]) {
        // Clear current input
        newOtp[index] = "";
        setOtp(newOtp);
      } else if (index > 0) {
        // Move focus back and clear previous
        inputRefs.current[index - 1]?.focus();
        newOtp[index - 1] = "";
        setOtp(newOtp);
      }
    }
  };

  return (
    <div style={{ display: "flex", justifyContent: "center", gap: 16 }}>
      {otp.map((digit, index) => (
        <Input
          key={index}
          type="tel"
          maxLength={1}
          value={digit}
          onChange={(e) => handleChange(index, e.target.value)}
          onKeyDown={(e) => handleKeyDown(index, e)}
          ref={(el) => (inputRefs.current[index] = el)}
        />
      ))}
    </div>
  );
};

export default OTPInput;
